import { NavigationGuard } from 'vue-router'
import { useSingleGroupMemento } from '@teams/common/hooks/useMemento'
import { initStore } from '@/store'
import { useUserStore } from '@/store/user'
import { useGroupStore } from '@/store/group'

type IRouterHandler = Record<
  string,
  (args: Parameters<NavigationGuard>) => Promise<void>
>

const userStore = useUserStore()

// 初始化空间备忘录 groupId不存在仅初始化副作用（切换团队需要）
export const initSingleGroupMemento = async (groupId?: string) => {
  const singleGroupMemento = useSingleGroupMemento()
  try {
    // 都需要初始化userStore (空间列表需要)
    await userStore.getCurrentAccount()
    // 都需要初始化workSpace信息
    await userStore.getCurrentWorkspace()
    if (groupId) {
      await singleGroupMemento.originator.changeState(() => ({
        groupId: groupId,
        userId: userStore.userId as number,
        shouldFlushStore: true,
        shouldFlushUsePreference: true,
        shouldFlushUseTeamShare: true
      }))
      singleGroupMemento.careTaker.backup()
    }
  } catch (error) {}
  singleGroupMemento.addAutoHandleSideEffectListener()
}

export const routerHandler: IRouterHandler = {
  Index: async args => {
    const [, , next] = args
    try {
      await initSingleGroupMemento()
    } catch (error) {}
    return next()
  },
  NotFound: async args => {
    // groupId校验异常(非纯数字) => 不需要请求空间信息
    const [, , next] = args
    try {
      await initSingleGroupMemento()
    } catch (error) {}
    return next()
  },
  Nav: async args => {
    const [to, , next] = args
    const groupStore = useGroupStore()
    const groupId = to.params.groupId as string
    try {
      await initSingleGroupMemento(groupId)
      // 检测空间是否存在
      await groupStore
        .fetchGroupInfo({
          throwError: true,
          groupId: Number(to.params.groupId)
        })
        .then(async () => {
          await initStore(groupId)
        })
    } catch (error) {
      // console.error(error)
    }
    return next()
  },
  // 进入分享链接
  Join: async args => {
    const [to, , next] = args
    const groupStore = useGroupStore()
    const groupId = to.params.groupId as string
    try {
      await initSingleGroupMemento(groupId)
      // 检测空间是否存在
      await groupStore.fetchGroupInfo({
        throwError: true,
        groupId: Number(to.params.groupId)
      })
      await initStore(groupId)
      if (!userStore.role?.isGroupMember) {
        // 非成员
        await groupStore.fetchInviteInfo(groupId)
        groupStore.setIsFromInviteUrl(true)
      }
    } catch (error) {}
    return next({ name: 'Home', params: { groupId: groupId } })
  },
  JumpLink: async args => {
    const [, , next] = args
    return next()
  }
}
